<template>
  <div class="container scorecard">
    <div class="row">
      <div class="col-5 lineUp gap-1 p-0 pe-1">
        <div class="d-flex gap-1 score-row">
          <h3 class="text-uppercase m-0 text-left flex-1 align-self-end xl-small">Visitor Line-Up</h3>
          <div class="playerGender align-self-end xxl-small">M/F</div>
          <div class="playerNumber align-self-end xxl-small">No</div>
        </div>
        <div v-for="n in 5" :key="n" :class="'d-flex score-row gap-1 lineUpPos-' + n">
          <div class="border border- 1 border-bb5yellow lineUpPos">
            <div class="m-0">{{ n }}</div>
          </div>
          <div class="player d-flex flex-column gap-1 xxl-small">
            <div class="regular d-flex flex-row gap-1">
              <div class="border border- 1 border-bb5yellow playerName"
                :class="'text-left visitor-' + guestLineUp[n - 1].lineUpPosition">{{ guestLineUp[n - 1].name.length > 36 ?
                  shortName(guestLineUp[n - 1].name) : guestLineUp[n-1].name }}</div>
              <div class="border border- 1 border-bb5yellow playerGender text-uppercase"
                :class="'visitor-' + guestLineUp[n - 1].lineUpPosition">{{ guestLineUp[n - 1].gender }}</div>
              <div class="border border- 1 border-bb5yellow playerNumber"
                :class="'visitor-' + guestLineUp[n - 1].lineUpPosition">{{ guestLineUp[n - 1].number }}</div>
            </div>
            <div class="substitute d-flex flex-row gap-1">
              <div class="border border- 1 border-bb5yellow text-uppercase font-weight-bold">SUB</div>
              <div v-if="!guestSubstitute[n - 1]" class="border border- 1 border-bb5yellow empty"></div>
              <div v-if="guestSubstitute[n - 1]" class="border border- 1 border-bb5yellow playerName text-left"
                :class="'visitor-' + guestSubstitute[n - 1].lineUpPosition">{{ guestSubstitute[n - 1].name.length > 24 ?
                  shortName(guestSubstitute[n - 1].name) : guestSubstitute[n-1].name }}</div>
              <div v-if="guestSubstitute[n - 1]" class="border border- 1 border-bb5yellow playerGender text-uppercase"
                :class="'visitor-' + guestSubstitute[n - 1].lineUpPosition">{{ guestSubstitute[n - 1].gender }}</div>
              <div v-if="guestSubstitute[n - 1]" class="border border- 1 border-bb5yellow playerNumber"
                :class="'visitor-' + guestSubstitute[n - 1].lineUpPosition">{{ guestSubstitute[n - 1].number }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-7 score p-0 ps-1">
        <div class="d-flex gap-1">
          <div class="inning" v-for="(inningGroups, inningIndex) in filteredGuestGroupedPlays" :key="inningIndex">
            
            <!-- Gruppen nebeneinander -->
            <div class="inning-columns">
              <!-- Schleife pro Gruppe innerhalb eines Innings -->
              <div class="column gap-1" v-for="(group, groupIndex) in inningGroups" :key="groupIndex">
                <div class="score-row d-flex"><span class="align-self-end xxl-small">{{ inningIndex + 1 }}</span></div>
                <!-- Inhalte einer Gruppe -->
                <div class="d-flex gap-1 flex-column position-absolute">
              <div v-for="n in 6" :key="n" class="play-empty score-row" :class="[n > 1 ? 'score-box' : '']"></div>
            </div>
                <div v-for="(play, playIndex) in group" :key="playIndex" class="play score-row " :class="[
                  'guest_lp_' + play.lineUpPosition.guest,
                  'group_' + groupIndex,
                  'action-' + play.action.toLowerCase(),
                  play.relatedAction ? 'action-' + play.relatedAction.toLowerCase() : '',
                  {
                    'add-bottom-border':
                      groupIndex === inningGroups.length - 1 && playIndex === group.length - 1 && threeOuts(inningGroups)

                  },
                  {
                    'add-left-border': play.relatedAction === 'substitute'

                  }
                ]">
                  <!-- Leere Inhalte für Platzhalter -->
                  <div v-if="play.isPlaceholder" class="action-empty">-</div>

                  <!-- Inhalte für tatsächliche Plays -->
                  <div v-else class="action">
                    {{ play.action === 'runner' ? 'R' : '' || play.action === 'hit' ? 'H' : '' || play.action === 'safe'
                    ? 'S' : '' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inning" v-for="(inningGroups, inningIndex) in 8 - groupCount('guest')" :key="inningIndex">
            <div class="d-flex gap-1 flex-column position-relative">
              <div v-for="n in 6" :key="n" class="score-row" :class="[n > 1 ? 'score-box' : '']"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-5 lineUp gap-1 p-0 pe-1">
        <div class="d-flex gap-1 score-row">
          <h3 class="text-uppercase m-0 text-left flex-1 align-self-end xl-small">Home Line-Up</h3>
          <div class="playerGender align-self-end xxl-small">M/F</div>
          <div class="playerNumber align-self-end xxl-small">No</div>
        </div>
        <div v-for="n in 5" :key="n" :class="'d-flex score-row gap-1 lineUpPos-' + n">
          <div class="border border- 1 border-bb5yellow lineUpPos">
            <div class="m-0">{{ n }}</div>
          </div>
          <div class="player d-flex flex-column gap-1 xxl-small">
            <div class="regular d-flex flex-row gap-1">
              <div class="border border- 1 border-bb5yellow playerName"
                :class="'text-left visitor-' + homeLineUp[n - 1].lineUpPosition">{{ homeLineUp[n - 1].name.length > 36 ?
                  shortName(homeLineUp[n - 1].name) : homeLineUp[n-1].name }}</div>
              <div class="border border- 1 border-bb5yellow playerGender text-uppercase"
                :class="'visitor-' + homeLineUp[n - 1].lineUpPosition">{{ homeLineUp[n - 1].gender }}</div>
              <div class="border border- 1 border-bb5yellow playerNumber"
                :class="'visitor-' + homeLineUp[n - 1].lineUpPosition">{{ homeLineUp[n - 1].number }}</div>
            </div>
            <div class="substitute d-flex flex-row gap-1">
              <div class="border border- 1 border-bb5yellow text-uppercase font-weight-bold">SUB</div>
              <div v-if="!homeSubstitute[n - 1]" class="border border- 1 border-bb5yellow empty"></div>
              <div v-if="homeSubstitute[n - 1]" class="border border- 1 border-bb5yellow playerName text-left"
                :class="'visitor-' + homeSubstitute[n - 1].lineUpPosition">{{ homeSubstitute[n - 1].name.length > 24 ?
                  shortName(homeSubstitute[n - 1].name) : homeSubstitute[n-1].name }}</div>
              <div v-if="homeSubstitute[n - 1]" class="border border- 1 border-bb5yellow playerGender text-uppercase"
                :class="'visitor-' + homeSubstitute[n - 1].lineUpPosition">{{ homeSubstitute[n - 1].gender }}</div>
              <div v-if="homeSubstitute[n - 1]" class="border border- 1 border-bb5yellow playerNumber"
                :class="'visitor-' + homeSubstitute[n - 1].lineUpPosition">{{ homeSubstitute[n - 1].number }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-7 score p-0 ps-1">
        <div class="d-flex gap-1">
          <div class="inning" v-for="(inningGroups, inningIndex) in filteredHomeGroupedPlays" :key="inningIndex">
            <!-- Gruppen nebeneinander -->
            <div class="inning-columns">
              <!-- Schleife pro Gruppe innerhalb eines Innings -->
              <div class="column gap-1" v-for="(group, groupIndex) in inningGroups" :key="groupIndex">
              
                <div class="score-row d-flex"><span class="align-self-end xxl-small">{{ inningIndex + 1 }}</span></div>
                <div class="d-flex gap-1 flex-column position-absolute">
                  <div v-for="n in 6" :key="n" class="play-empty score-row" :class="[n > 1 ? 'score-box' : '']"></div>
                </div>
                <!-- Inhalte einer Gruppe -->
                <div v-for="(play, playIndex) in group" :key="playIndex" class="play score-row " :class="[
                  'guest_lp_' + play.lineUpPosition.guest,
                  'group_' + groupIndex,
                  'action-' + play.action.toLowerCase(),
                  play.relatedAction ? 'action-' + play.relatedAction.toLowerCase() : '',
                  {
                    'add-bottom-border':
                      groupIndex === inningGroups.length - 1 && playIndex === group.length - 1 && threeOuts(inningGroups)

                  },
                  {
                    'add-left-border': play.relatedAction === 'substitute'

                  }
                ]">
                  <!-- Leere Inhalte für Platzhalter -->
                  <div v-if="play.isPlaceholder" class="action-empty">-</div>

                  <!-- Inhalte für tatsächliche Plays -->
                  <div v-else class="action">
                    {{ play.action === 'runner' ? 'R' : '' || play.action === 'hit' ? 'H' : '' || play.action === 'safe'
                    ? 'S' : '' }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="inning" v-for="(inningGroups, inningIndex) in 8 - groupCount('home')" :key="inningIndex">
            <div class="d-flex gap-1 flex-column position-relative">
              <div v-for="n in 6" :key="n" class="score-row" :class="[n > 1 ? 'score-box' : '']"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="rowform-check form-switch pt-1">
      <input class="form-check-input" type="checkbox" id="runsNError" name="runsNError" v-model="runsNError" value="false">
      <label class="form-check-label xxl-small" for="runsNError">show Runs & Errors</label>
    </div>
    <div class="row" v-if="runsNError">
      <div class="col-2 d-flex flex-column gap-1 p-0">

        <div class="runs-visitor runs-row d-flex gap-1">
          <div class="text-uppercase font-weight-bold flex-1"></div>
        </div>
        <div class="runs-visitor runs-row d-flex gap-1">
          <h3 class="text-uppercase font-weight-bold flex-1 xl-small text-left m-0">Visitor</h3>
        </div>
        <div class="runs-visitor runs-row d-flex gap-1">
          <h3 class="text-uppercase font-weight-bold flex-1 xl-small text-left m-0">Home</h3>
        </div>

      </div>
      <div class="col-10 d-flex flex-column gap-1 p-0">
        <div class="runs-visitor runs-row d-flex gap-1">
          <div v-for="(n, index) in 10" :key="index" class="runs-box text-uppercase xxl-small head">
            {{ getInningLabel(n) }}
          </div>
        </div>
        <div class="runs-visitor runs-row d-flex gap-1">
          <h3 v-for="(n, index) in 9" :key="index" class="runs-box xl-small m-0">
            {{ score.inning.length >= n ? runsPerInning(n - 1, 'guest') : '' }}
          </h3>
          <h3 class="runs-box xl-small m-0">{{ score.inning[0]?.play[0]?.score['guest'] }}</h3>
        </div>
        <div class="runs-home runs-row d-flex gap-1">
          <h3 v-for="(n, index) in 9" :key="index" class="runs-box xl-small m-0">
            {{ score.inning.length >= n ? runsPerInning(n - 1, 'home') : '' }}
          </h3>
          <h3 class="runs-box xl-small m-0">{{ score.inning[0]?.play[0]?.score['home'] }}</h3>
        </div>
      </div>
    </div>
    <div class="row mt-2" v-if="runsNError">
      <div class="col-2 d-flex flex-column gap-1 p-0">
        <div class="runs-visitor runs-row d-flex gap-1">
          <h3 class="text-uppercase font-weight-bold flex-1 xl-small text-left m-0">Visitor</h3>
        </div>
        <div class="runs-visitor runs-row d-flex gap-1">
          <h3 class="text-uppercase font-weight-bold flex-1 xl-small text-left m-0">Home</h3>
        </div>

      </div>
      <div class="col-10 d-flex flex-column gap-1 p-0">
        <div class="d-flex gap-1 runs-row ">
          <div v-for="n in 10" :key="n" class="score-row error-box">
            {{ shouldDisplayX(score.inning, 'guest', n) }}
          </div>
        </div>
        <div class="d-flex gap-1 runs-row ">
          <div v-for="n in 10" :key="n" class="score-row error-box">
            {{ shouldDisplayX(score.inning, 'home', n) }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import core from '@/mixins/Core';

export default {
  data() {
    return {
      inningMax: 10,
      isLoading: true,
      guestLineUp: [],
      homeLineUp: [],
      guestSubstitute: [],
      homeSubstitute: [],
      runsNError: false,
    };
  },
  mixins: [core],
  computed: {
    ...mapState(['teams', 'game', 'stats', 'score']),
    ...mapGetters(['findPlayerInScore']),
    filteredHomeGroupedPlays() {
      return this.groupedPlays('home').filter(inningGroups => inningGroups.length > 0);
    },
    filteredGuestGroupedPlays() {
      return this.groupedPlays('guest').filter(inningGroups => inningGroups.length > 0);
    }
  },
  async created() {
    this.guestLineUp = this.getLineUp('guest');
    this.guestSubstitute = this.getSubLineUp('guest');
    this.homeLineUp = this.getLineUp('home');
    this.homeSubstitute = this.getSubLineUp('home');
    this.isLoading = false;
    // }
  },
  methods: {
    getInningLabel(n) {
      return `${n <= 9 ? n : 'total'}${n > 5 && n < 10 ? ' EX' : ''}`;
    },
    ...mapActions(['setScore']),
    async initializeScore() {
      const gameId = localStorage.getItem('currentgame');
      // Hol die Score-Daten vom Server
      const score = await this.getData('getScore', { id: gameId });
      // Update deinen `score`-State oder Vuex
      this.setScore(score.score);
      this.isLoading = false;

      // Falls nötig, lade weitere Abhängigkeiten
    },
    groupedPlays(team) {
      return this.score.inning
        .slice() // Erstelle eine Kopie des Arrays, um das Original nicht zu verändern
        .reverse() // Kehre die Reihenfolge der Innings um
        .filter((inning) => inning.play && inning.play.length > 0) // Filtere Innings mit gültigen Plays
        .map((inning) => {
          // Filtere Plays für das angegebene Team

          const offsetPlays = inning.play.filter((play) => play.team === team && (play.action === 'hit' || play.action === 'safe' || play.action === 'scored' || play.action === 'out' || play.action === 'batterout' || play.action === 'runner')).reverse();
          const filteredPlays = inning.play.filter((play) => play.team === team && (play.action === 'hit' || play.action === 'safe' || play.action === 'scored' || play.action === 'out' || play.action === 'batterout' || play.action === 'runner' || play.action === 'substitute')).reverse();

          // Wenn keine Plays für das Team vorhanden sind, überspringen 
          if (offsetPlays.length === 0) return [];

          // Prüfe den Offset: Finde den `lineup`-Wert des ersten Plays
          const firstLineup = offsetPlays[0]?.lineup - 1 || 0;
          const offset = firstLineup === 1 ? 0 : firstLineup === 0 ? 4 : firstLineup - 1
          // Füge leere Plätze für das Offset hinzu
          const adjustedPlays = [];
          for (let i = 1; i <= offset; i++) {
            adjustedPlays.push({ lineup: i, action: '', isPlaceholder: true, lineUpPosition: { guest: i, home: i } });
          }

          // Füge die bereinigten Plays hinzu
          adjustedPlays.push(...filteredPlays);

          // Gruppiere die Plays basierend auf `lineup`
          const groups = [];
          let currentGroup = [];
          let previousPlayWasSubstitute = false; // Track if the previous play was a substitute

          adjustedPlays.forEach((play, index) => {
            if (previousPlayWasSubstitute) {
              // Use the information that the previous play was a substitute
              play.relatedAction = 'substitute';
            }

            if (play.action === 'substitute') {
              previousPlayWasSubstitute = true; // Set the flag for the next play
              return; // Skip the substitute play itself
            } else {
              previousPlayWasSubstitute = false; // Reset the flag if the current play is not a substitute
            }
            if (play.action === 'scored' || play.action === 'out') {
              // Suche in den vorherigen Plays nach einem Play mit 'hit' oder 'safe'
              for (let i = index - 1; i >= 0; i--) {
                const previousPlay = adjustedPlays[i];
                // console.log('previousPlay', previousPlay);
                if (play.playerId !== previousPlay.playerId) {
                  // Überspringe Plays mit unterschiedlichen Spieler-IDs
                  continue;
                }
                if (previousPlay.action === 'out' || previousPlay.action === 'scored') {
                  // Überspringe Plays mit 'out' oder 'scored'
                  continue;
                }
                if (previousPlay.action === 'hit' || previousPlay.action === 'safe' || previousPlay.action === 'runner') {
                  // Schreibe die `relatedAction` in das `previousPlay`
                  previousPlay.relatedAction = play.action;
                  break;
                }
              }
              return
            }

            currentGroup.push(play);
            // Schließe die Gruppe ab, wenn `lineup` 5 erreicht
            if (currentGroup.length === 5) {
              groups.push(currentGroup);
              currentGroup = [];
            }
          });

          // Letzte Gruppe hinzufügen, falls noch Plays übrig sind
          if (currentGroup.length > 0) {
            groups.push(currentGroup);
          }

          return groups;
        });
    },
    groupCount(team) {
      return this.groupedPlays(team).reduce((count, subArray) => count + subArray.length, 0);
    },
    getLineUp(team) {
      const players = this.findTeam(team)
        .filter(player => player.lineUpPosition !== undefined) // Optional: Nur Spieler mit lineUpPosition
        .sort((a, b) => a.lineUpPosition - b.lineUpPosition) // Nach Position sortieren
        .slice(0, 5);
      const lineUp = players.map(player => ({
        ...player, // Ursprüngliche Informationen des Spielers
        ...this.findPlayerInScore(player.id), // Zusätzliche Daten aus this.teams
      }));
      return lineUp
    },
    getSubLineUp(team) {
      let lineUp = Array(5).fill(null); // Initialisiere ein Array mit 5 Elementen (alle `null`)

      for (const inning of this.score.inning) {
        const plays = inning.play.filter((play) => play.action === 'substitute' && play.team === team);

        for (const play of plays) {
          const player = this.findPlayerInScore(play.playerId);
          if (player) {
            const lineUpPosition = play.positions[play.team].find(player => player.id === play.playerId)?.lineUpPosition;

            // Füge den Spieler an der entsprechenden Position ein, wenn die Position gültig ist
            if (lineUpPosition >= 1 && lineUpPosition <= 5) {
              lineUp[lineUpPosition - 1] = {
                ...player,
                lineUpPosition,
              };
            }
          }
        }
      }
      return lineUp
    },
    threeOuts(group) {
      if (!Array.isArray(group) || group.length === 0) {
        return false; // Nichts zu tun bei leerer Gruppe
      }
      // Gehe durch alle Gruppen und summiere die eindeutigen "X"-Vorkommen
      const totalXCount = group.reduce((total, subGroup) => {
        return (
          total +
          subGroup.reduce((subTotal, play) => {
            // Prüfe, ob "X" mindestens einmal im aktuellen play vorkommt
            const hasX = play.action === 'out' || play.action === 'batterout' || play.relatedAction === 'out';
            return subTotal + (hasX ? 1 : 0); // Zähle nur einmal pro play
          }, 0)
        );
      }, 0);

      // Bedingung: Gibt true zurück, wenn mindestens 3 eindeutige "X" vorhanden sind
      return totalXCount >= 3;
    },
    shouldDisplayX(innings, team, n) {
      return this.countErrors(innings, team) >= n ? 'X' : '';
    },
    countErrors(innings, team) {
      if (!Array.isArray(innings)) {
        return 0;
      }
      const errors = innings.reduce((total, inning) => {
        // Skip null oder ungültige Innings
        if (!Array.isArray(inning.play) || inning.play.length === 0) return total;

        // Zähle alle Plays in diesem Inning mit dem gesuchten Action
        const inningErrors = inning.play.reduce((count, play) => {
          if (!play || !play.action) return count;
          const hasError = play.action === 'error' && play.team === team;
          return count + (hasError ? 1 : 0);
        }, 0);

        return total + inningErrors;
      }, 0);

      return errors;
    },
    getGameStats() {
      const totalInnings = Math.max(...this.stats.map(stat => stat.game.inning)); // Bestimmt die maximale Anzahl der Innings
      const inningsStats = Array.from({ length: totalInnings }, (_, i) => i + 1) // Erstellt ein Array mit allen Innings [1, 2, 3, ...]

      return inningsStats.map(inning => {
        const inningStats = this.stats
          .filter(stat => stat.game.inning === inning && stat.action && stat.action.length > 0) // Filtert Stats für das aktuelle Inning mit gültigen Actions

        return {
          inning,
          actions: inningStats.map(stat => ({
            action: stat.action,
            playerId: stat.player.id,
            lineUpPosition: this.getPlayerLineUpPosition(stat.player.id),
            team: stat.team,
          })),
        };
      });
    },
    getPlayerLineUpPosition(playerId) {
      // Kombiniert alle Spieler aus den Teams "guest" und "home"
      const allPlayers = [
        ...(this.game.guest?.players || []),
        ...(this.game.home?.players || [])
      ];
      // Findet den Spieler anhand der ID
      const player = allPlayers.find(player => player.id === playerId);

      // Gibt die lineUpPosition zurück oder `null`, falls der Spieler nicht gefunden wurde
      return player?.lineUpPosition || null;
    },
    runsPerInning(inningIndex, team) {
      const inning = this.score.inning.reverse()[inningIndex].play.filter((play) => (play.action === 'scored') && play.offenceTeam === team);
      return inning.length;
    },
    findTeam(teamSide) {
      for (const inning of this.score.inning) {
        const startPlay = inning.play.find((play) => play.action === 'start');
        if (startPlay) {
          return startPlay.positions[teamSide]; // Gibt das erste gefundene Play mit der Aktion 'start' zurück
        }
      }
    },
    toogleRunsNError() {
      this.runsNError = !this.runsNError;
    },
  },
};
</script>

<style scoped>
.ratio-1 {
  aspect-ratio: 1 / 1;
}

.border-bb5yellow {
  --bs-border-color: var(--bb5-yellow) !important;
}

.background-container {
  position: relative;
  display: inline-block;
  /* Die Breite und Höhe orientieren sich am Inhalt (Bild) */
  width: 100%;
  /* Optional: Breite auf 100% setzen, um es responsiv zu machen */
  text-align: center;
  /* Zentriert den Inhalt im Container */
}

.flex-1,
.player,
.playerName {
  flex: 1;
}

.lineUpPos,
.playerGender,
.playerNumber {
  min-width: 0.8rem;
  text-align: center;
}

.empty {
  flex: 1;
  content: "";
}

.font-weight-bold {
  font-weight: bold;
}

.text-left {
  text-align: left;
}

.xl-small {
  font-size: 1em;
}

.xxl-small {
  font-size: 0.5em;
}

.gap-1 {
  gap: 0.1rem !important;
}

.lineUp {
  display: flex;
  flex-direction: column;
  /* Titel oben, Inhalte unten */
  text-align: center;
  font-size: 0.8em;
  font-weight: bold;
}

.score-row {
  height: 1.55rem;
}

.score-box {
  width: 1.5rem;
  border: 1px solid var(--bb5-yellow);
}

.runs-row {
  height: 1.55rem;
  align-content: center;
}

.runs-box {
  width: 1.5rem;
  border: 1px solid var(--bb5-yellow);
  text-align: center;
}

.runs-box.head {
  padding-left: 2px;
  align-content: end;
  text-align: left;
  border: none;
}

.error-box {
  width: 1rem;
  height: 1rem;
  border: 1px solid var(--bb5-yellow);
  border-radius: 50%;
  font-weight: bold;
  padding-left: 1px;
  line-height: 1rem;
}

.play {
  width: 1.5rem;
  border: 1px hidden var(--bb5-yellow);
  position: relative;
}

.background-image {
  display: block;
  /* Entfernt Lücken unterhalb des Bildes (inline-Eigenschaften) */
  max-width: 100%;
  /* Bild passt sich der Breite des Containers an (Responsivität) */
  height: auto;
  /* Höhe passt sich proportional an die Breite an */
}

.content {
  position: absolute;
  /* Positioniert den Inhalt relativ zum Container */
  top: 0;
  width: 100%;
  /* Gleiche Breite wie der Container */
  height: 100%;
  color: black;
  /* Weißer Text */
}

.home,
.visitor {
  font-size: 0.8vw;
  position: absolute;
}

.homeName,
.visitorName {
  left: 7%;
}

.homeGender,
.visitorGender {
  left: 23.7%;
}

.homeNumber,
.visitorNumber {
  left: 25.7%;
}

.homeSubPlayer-1 .homeName,
.homeSubPlayer-2 .homeName,
.homeSubPlayer-3 .homeName,
.homeSubPlayer-4 .homeName,
.homeSubPlayer-5 .homeName,
.visitorSubPlayer-1 .visitorName,
.visitorSubPlayer-2 .visitorName,
.visitorSubPlayer-3 .visitorName,
.visitorSubPlayer-4 .visitorName,
.visitorSubPlayer-5 .visitorName {
  left: 9.5%;
  max-width: 12em;
  overflow: hidden;
  height: 1.5em;
  text-align: left;
}

.visitor-1 {
  top: 21.5%;
}

.visitorSubPlayer-1 .visitor-1 {
  top: 23.5%;
}

.visitor-2 {
  top: 26.5%;
}

.visitorSubPlayer-2 .visitor-2 {
  top: 28.5%;
}

.visitor-3 {
  top: 31.7%;
}

.visitorSubPlayer-3 .visitor-3 {
  top: 33.7%;
}

.visitor-4 {
  top: 36.7%;
}

.visitorSubPlayer-4 .visitor-4 {
  top: 38.7%;
}

.visitor-5 {
  top: 42%;
}

.visitorSubPlayer-5 .visitor-5 {
  top: 44%;
}

.home-1 {
  top: 54%;
}

.homeSubPlayer-1 .home-1 {
  top: 56%;
}

.home-2 {
  top: 59.5%;
}

.homeSubPlayer-2 .home-2 {
  top: 61.5%;
}

.home-3 {
  top: 64.5%;
}

.homeSubPlayer-3 .home-3 {
  top: 66.5%;
}

.home-4 {
  top: 70%;
}

.homeSubPlayer-4 .home-4 {
  top: 72%;
}

.home-5 {
  top: 75%;
}

.homeSubPlayer-5 .home-5 {
  top: 77%;
}

.title {
  font-size: 2rem;
  font-weight: bold;
}

.action-scored::before {
  content: '';
  border: 0.5vw solid #000;
  border-radius: 50%;
  display: block;
  position: absolute;
  width: 100%;
  height: 100%;
}

.action-xe::before {
  content: '\274c';
  /* Zeigt ein großes "X" */
  display: block;
  position: relative;
  width: 100%;
  height: 100%;
}

.action-batterout,
.action-out {
  position: relative;
}

.action-batterout::before,
.action-batterout::after,
.action-out::before,
.action-out::after {
  content: '';
  position: absolute;
  top: -25%;
  left: 45%;
  width: 0.5vw;
  height: 150%;
  background-color: black;
  transform-origin: center;
}

.action-batterout::before,
.action-out::before {
  transform: rotate(45deg);
}

.action-batterout::after,
.action-out::after {
  transform: rotate(-45deg);
}

.visitorScore {
  display: flex;
  flex-direction: row;
  /* Zeigt alle Innings nebeneinander */
  gap: 0.2rem;
  /* Abstand zwischen den Innings */
  justify-content: flex-start;
  position: absolute;
  top: 17.8%;
  left: 27.2%;
}

.homeScore {
  display: flex;
  flex-direction: row;
  /* Zeigt alle Innings nebeneinander */
  gap: 0.2rem;
  /* Abstand zwischen den Innings */
  justify-content: flex-start;
  position: absolute;
  top: 53.5%;
  left: 27%;
}

.inning {
  display: flex;
  flex-direction: column;
  /* Titel oben, Inhalte unten */
  text-align: center;
  min-width: 1.5rem;
}

.inning .group-head {
  font-size: 1vw;
  text-align: left;
  padding-left: 0.2vw;
}

.inning-title {
  font-weight: bold;
  margin-bottom: 1rem;
  font-size: 1.2rem;
}

.inning-columns {
  display: flex;
  flex-direction: row;
  /* Columns nebeneinander anzeigen */
  gap: 0.2rem;
  /* Abstand zwischen den Columns */
  justify-content: space-between;
}

.column {
  display: flex;
  flex-direction: column;
  /* Inhalte wie Plays innerhalb der Column untereinander anzeigen */
  text-align: center;
  gap: 0.32vw;
}

.home_lp.play,
.guest_lp.play {
  border: 1px solid #ddd;
  width: 2.9vw;
  height: 2.9vw;
  align-items: center;
  display: flex;
  justify-content: center;
}

.action {
  font-weight: 700;
  font-size: 1.5em;
  line-height: 1.55rem;
  font-style: italic;
}

.action-empty {
  opacity: 0;
}

.add-bottom-border {
  border-bottom: 4px solid #000 !important;
}

.add-left-border {
  border-left: 4px solid #000 !important;
  margin-left: -2px;
  z-index: 1;
}

.officials {
  position: absolute;
  right: 24%;
  top: 42%;
}

.officials div {
  font-size: 1vw;
  padding-bottom: 2vw;
  text-align: left
}

.gameInfo {
  position: absolute;
  right: 5%;
  top: 18%;
  min-width: 13vw;
}

.gameInfo div {
  font-size: 1vw;
  padding-bottom: 0.32vw;
  text-align: left
}

.time {
  position: absolute;
  left: 14%;
  top: 90.4%;
}

.time div {
  font-size: 1vw;
  padding-bottom: 0.26vw;
  text-align: left
}

.errors {
  position: absolute;
  font-family: Hatten;
  left: 76.5%;
  bottom: 6.1%;
  text-align: left;
}

.errors div {
  display: flex;
  column-gap: 0.9vw;
  min-height: 1em;
  line-height: 1em;
}

.totalErrors {
  position: absolute;
  font-family: Hatten;
  right: 4%;
  top: 86.6%;
  font-size: 2vw;
  line-height: 2.2vw;
}

.totalErrors div {
  text-align: left
}

.runs {
  position: absolute;
  font-family: Hatten;
  left: 28.2%;
  top: 85%;
  font-size: 2.5vw;
  line-height: 3.2vw;
}

.runs div {
  display: flex;
  column-gap: 2.4vw;
}

.totalRuns {
  position: absolute;
  font-family: Hatten;
  left: 61.6%;
  top: 85%;
  font-size: 2.5vw;
  line-height: 3.2vw;
}
.form-check-input:checked {
  background-color: var(--bs-highlight-color);
    border-color: var(--bs-highlight-color);
}
</style>